module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "pageTitle pageTitle--dark"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n         " + _vm._s(_vm.$t('static.batches.edit.title')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    attrs: {
      "value": "1"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.batches.formTabs.batchInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('div', {
    staticClass: "margin-b-20"
  }, [_c('label', {
    staticStyle: {
      "width": "180px",
      "display": "inline-block"
    },
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Select One:")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "id": "status"
    },
    on: {
      "change": _vm.handleStatusChange
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "planned"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.planned')) + "\n              ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "started"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.started')) + "\n              ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "completed"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.batches.statuses.completed')) + "\n              ")])], 1)], 1), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.batches",
      "hasLabel": true
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'production.batches.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a7b421a","hasScoped":false}!./src/app/pages/withNavigation/batches/edit/edit.html
// module id = 3074
// module chunks = 1